<template lang="pug">
  .l-content(@click.stop="onTap")
    .l-container
      .c-container
        .c-container__image.u-text-center
          img.icon(:src="icon")
        .c-container__title.u-ptm.u-text-center
          slot(name="title")
        .c-container__annotation
          slot(name="description")
</template>

<script lang="babel">
  export default {
    name: 'Cover',
    props: {
      icon: {
        type: String,
        required: true
      },
    },
    methods: {
      onTap() {
        this.$emit('screen-got-tapped')
      },
    }
  }
</script>

<style lang="scss" scoped>
  .l-content {
    height: 100%;
  }
  .c-container {
    overflow: hidden;
    padding: {
      top: 75px;
    }
    &__title {
      font-size: 22px;
      line-height: 36px;
      text-align: center;
      letter-spacing: 0.03em;
      margin-bottom: 40px;
    }
    &__annotation {
      font-size: 14px;
      line-height: 24px;
      letter-spacing: 0.03em;
      color: #A6A5A5;
      &.u-mtm {
        margin-top: 36px;
      }
      .c-label {
        margin-left: 0px;
      }
    }
  }
  .l-container.is-bottom {
    .c-button-float-lg {
      position: fixed;
      bottom: 24px;
      right: 16px;
      color: white;
      background-color: #F94848;
      box-shadow: 0px 5px 12px rgba(111, 0, 24, 0.2);
      .material-icons {
        vertical-align: initial;
      }
    }
    .c-button-floating-action-group {
      button:disabled {
        background: #E0E0E0;
      }
    }
  }
  .icon {
    max-width: 88px;
  }
</style>
